<template>
    <div class="new-speak">
        <div class="new-speak-content">
            <div class="head">
                <div class="pro-type" style="padding:0 24px">
                    <span>项目类型选择</span>
                </div>
                <div class="belongs-industry" style="font-size:14px;display:flex;padding:0 24px 20px">
                    <div style="color:rgba(153, 153, 153, 1);width:100px;line-height:35px">选择所属行业：</div>
                    <div style="flex:1">
                        <span @click="selectCurrentIndustry(-1,'')" :class="{'active':selectedIndustry==-1}" style="margin-right:24px;cursor:pointer;line-height:35px">全部</span>
                        <span @click="selectCurrentIndustry(index,item.id)" :class="{'active':selectedIndustry==index}" style="margin-right:24px;cursor:pointer;line-height:35px" v-for="(item, index) in senceList" :key="index" >{{item.name}}</span>
                    </div>
                </div>
                <div class="call-type" style="padding:0 24px">
                    <div style="display:inline-block;float:left;color:rgba(153, 153, 153, 1);width:100px">选择项目类型：</div>
                    <a-radio-group name="radioGroup" :default-value="1" @change="chooseType">
                        <a-radio :value="1">
                        呼入
                        </a-radio>
                        <a-radio :value="2">
                        呼出
                        </a-radio>
                    </a-radio-group>
                </div>
            </div>
            <div class="body">
                <div v-if="ifShow">
                    <div class="card">
                        <div class="new">
                            <div style="cursor:pointer;display:inline-block;line-height:35px;color:rgba(34, 215, 187, 1);margin-top:10px" @click="newBlank">
                                <a-icon style="font-size:22px" type="plus" />
                                <div style="margin-left:5px;font-size:16px;color:#22d7bb;font-weight:600">空白创建</div>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-for="(item, index) in senceData" :key="index" :class="{'distance':((index+1)%4!=0)}">
                        <div class="card-title">
                            <span>{{item.name}}</span>
                        </div>
                        <div class="card-content">
                            <span>节点：</span>
                            <span style="margin-right:24px;">{{item.nodeCount}}</span>
                            <span>意图：</span>
                            <span style="margin-right:24px;">{{item.intentionCount}}</span>
                            <span>样本：</span>
                            <span>{{item.sampleCount}}</span>
                        </div>
                        <div class="card-foot">
                            <span style="float:left;color:rgba(204, 204, 204, 1);font-size:12px">{{item.createTime}}</span>
                            <span style="color:rgba(34, 215, 187, 1);float:right;font-size:14px">{{item.scene}}</span>
                        </div>
                        <div style="clear:both"></div>
                        <ul class="card-list">
                            <li @click="operate(index,'audio',item)">
                                <a-icon type="audio" />
                                <span>对话</span>
                                <span style="width:1px;height:15px;float:right;background:rgba(221, 221, 221, 1);margin-top:10px;"></span>
                            </li>
                            <li @click="operate(index,'copy',item)">
                                <a-icon type="copy" />
                                <span>克隆</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="!ifShow">
                    <div class="card">
                        <div class="new">
                            <div  style="cursor:pointer;display:inline-block;line-height:35px;color:rgba(34, 215, 187, 1);margin-top:10px" @click="newBlank">
                                <a-icon style="font-size:22px" type="plus" />
                                <div style="margin-left:5px;font-size:16px;color:#22d7bb;font-weight:600">空白创建</div>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-for="(item, index) in senceData" :key="index" :class="{'distance':((index+1)%4!=0)}">
                        <div class="card-title">
                            <span>{{item.name}}</span>
                        </div>
                        <div class="card-content">
                            <span>节点：</span>
                            <span style="margin-right:24px;">{{item.nodeCount}}</span>
                            <span>意图：</span>
                            <span style="margin-right:24px;">{{item.intentionCount}}</span>
                            <span>样本：</span>
                            <span>{{item.sampleCount}}</span>
                        </div>
                        <div class="card-foot">
                            <span style="float:left;color:rgba(204, 204, 204, 1);font-size:12px">{{item.createTime}}</span>
                            <span style="color:rgba(34, 215, 187, 1);float:right;font-size:14px">{{item.scene}}</span>
                        </div>
                        <div style="clear:both"></div>
                        <ul class="card-list">
                            <li @click="operate(index,'audio',item)">
                                <a-icon type="audio" />
                                <span>对话</span>
                                <span style="width:1px;height:15px;float:right;background:rgba(221, 221, 221, 1);margin-top:10px;"></span>
                            </li>
                            <li @click="operate(index,'copy',item)">
                                <a-icon type="copy" />
                                <span>克隆</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <router-link target="_blank" rel="opener" to="/Communication" class="dialogBox">
                <a-icon style="z-index:1000;font-size:25px" type="message" />
            </router-link> -->
        </div>
  </div>
</template>

<script>
export default {
    name: 'NewSpeak',
    props: {
        msg: String
    },
    data() {
        return {
            ifShow: true,
            showIndex: true,
            senceData: [],
            senceList: [],
            selectedIndustry: -1,
            currentSenceId: '',
            currentCallType: 'IN',
        }
    },
    methods: {
        chooseType(e) {
            if(e.target.value == 1){
                this.ifShow = true
                this.showIndex = true
                this.currentCallType = 'IN'
                this.querySenceData()
            }else{
                this.ifShow = false
                this.showIndex = false
                this.currentCallType = 'OUT'
                this.querySenceData()
            }
        },
        newBlank() {
            let sceneType
            if(this.showIndex){
                sceneType = 'IN'
            }else{
                sceneType = 'OUT'
            }
            this.axios.post('/api/project', {
                type: sceneType,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.$router.push({path: '/PublicPart',query:{projectId:response.data.data.projectId}});
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySenceData() {
            this.axios({
                url:'/api/project/template/list', 
                params:{
                    type: this.currentCallType,
                    sceneId: this.currentSenceId
                }
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.senceData = response.data.data
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        querySenceList() {
            this.axios({
                method:'get',
                url:'/api/dropdown/scene', 
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.senceList = response.data.data
                }else{
                   this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
        selectCurrentIndustry(index,id) {
            this.selectedIndustry = index
            this.currentSenceId = id
            this.querySenceData()
        },
        operate(index,param,item) {
            this.projectId = item.id
            if(param == 'copy'){
                this.$confirm({
                    title: '提示',
                    content: '确认要克隆该项目吗？',
                    okText: '确认',
                    cancelText: '取消',
                    icon: 'warning',
                    onOk: ()=> {
                        this.copyPro(item.id)
                    },
                })
            }else if(param == 'audio'){
                let routeData = this.$router.resolve({path: '/Communication',query:{projectId:this.projectId,projectName:item.name}});
                window.open(routeData.href, '_blank');
            }
        },
        copyPro(id){
            this.axios.post('/api/project/copy', {
                id: id,
            })
            .then(response=> {
                if(response.data.code == 0){
                    this.querySenceData()
                }else{
                    this.$message.error(response.data.message);
                }
            })
            .catch(error=> {
                console.log(error)
            })
        },
    },
    mounted: function() {
        this.querySenceData()
        this.querySenceList()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped  lang="less">
    .new-speak{
        height: 100%;
        background: rgba(240, 242, 243, 1);
        // padding: 24px;
        overflow-y: auto;
        .new-speak-content{
            width: 1440px;
            margin: 0 auto;
            .head{
                min-height: 126px;
                background: #fff;
                margin: 24px 0 16px;
                padding: 16px 0px 24px 0px;
                box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
                .pro-type{
                    text-align: left;
                    color: rgba(80, 80, 80, 1);
                    font-size: 18px;
                    text-align: left;
                    margin-bottom: 20px;
                    font-weight: bold;
                    height: 43px;
                    border-bottom: 1px solid rgba(240, 240, 240, 1);
                }
                .call-type {
                    span{
                        width: 80px;
                        height: 34px;
                        display: inline-block;
                        line-height: 34px;
                        text-align: center;
                        background: #fff;
                        color: rgba(34, 215, 187, 1);;
                        border: 1px solid rgba(34, 215, 187, 1);
                        border-radius: 4px;
                        margin-right: 20px;
                        font-size: 14px;
                        cursor: pointer;
                    }
                    span.active{
                        background: rgba(34, 215, 187, 1);
                        color: #fff;
                    }
                }
                .belongs-industry{
                    span{
                        color: rgb(80, 80, 80);
                    }
                    span.active{
                        color: rgba(34, 215, 187, 1);
                    }
                }
            }
            .body{
                .distance{
                    margin-left: 16px;
                }
                .card{
                    width: 348px;
                    height: 178px;
                    background: #fff;
                    -webkit-box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
                    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08);
                    margin-bottom: 16px;
                    padding-top: 24px;
                    float: left;
                    position: relative;
                    .new{
                        text-align: center;
                        padding-top:23px;
                    }
                    .card-title{
                        padding: 0 24px;
                        span:nth-child(1){
                            font-size: 16px;
                            font-weight: bold;
                            color: rgba(51, 51, 51, 1);
                        }
                    }
                    .card-content{
                        margin-top: 16px;
                        font-size: 14px;
                        padding: 0 24px;
                        color: rgba(153, 153, 153, 1);
                    }
                    .card-foot{
                        margin-top: 16px;
                        padding: 0 24px;
                    }
                    .card-list{
                        height: 35px;
                        color: rgb(153, 153, 153);
                        background-color: rgb(248, 249, 249);
                        font-size: 14px;
                        line-height: 35px;
                        text-align: center;
                        margin-bottom: 0px;
                        margin-top: 21px;
                        li{
                            cursor: pointer;
                            width: 50%;
                            float: left;
                        }
                    }
                }
            }
        }
    }

</style>
